export default __webpack_public_path__ + "static/media/manage.b8f82766.png";